<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" dark v-bind="attrs" v-on="on" @click="$refs.form.reset()">
          {{ $t("btn.UploadSlide") }}
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t("btn.UploadSlide") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-file-input show-size counter label="ภาพ Slide" required :rules="FileRules" accept="image/png, image/jpeg, image/bmp" prepend-icon="mdi-camera" v-model="FileSlide" hint="1950 x 1080 px" persistent-hint></v-file-input>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false" :loading="$store.getters.overlay">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="SaveClick" :loading="$store.getters.overlay">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
      
    </v-dialog>


    <v-dialog v-model="dialogComplete" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          บันทึกข้อมูลเรียบร้อย
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="ClickComplete">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  export default {
    data: () => ({
      dialog: false,
      FileSlide:null,
      valid:false,
      dialogComplete:false,
      FileRules: [
        v => !!v || 'File is required'
      ],
      req:{},
    }),
    methods: {
      
      SaveClick() {
        if(this.$refs.form.validate()){
          this.$store.commit('set_overlay',true);
          let formData = new FormData();
          formData.append('FileSlide',this.FileSlide,this.FileSlide.name);
          formData.append('locale',this.$store.getters.authen.locale);
          this.req.post(this.$store.getters.base_api + 'post-upload-slide',formData,{ headers: {'Content-Type': 'multipart/form-data'},})
                .then(response=>{
                  this.dialog = false;
                  this.dialogComplete = true;
                  this.$store.commit('set_overlay',false);
               }).catch(error => {
                  this.$store.commit('set_overlay',true);
              });
        }
      },
      ClickComplete(){
        this.dialogComplete = false;
        this.$emit('complete');
      },
    },
    mounted() {
      this.req = this.$store.getters.req;
      
    },
  }
</script>